export const classifyLink = (url, currentHost = typeof window !== "undefined" ? window.location.host : "") => {
  const trimmedUrl = typeof url === "string" ? url.trim() : "";

  if (!trimmedUrl) {
    return {
      href: "",
      isExternal: false,
    };
  }

  if (
    trimmedUrl.startsWith("/") ||
    trimmedUrl.startsWith("?") ||
    trimmedUrl.startsWith("#")
  ) {
    return {
      href: trimmedUrl,
      isExternal: false,
    };
  }

  try {
    const parsed = new URL(trimmedUrl);
    if ((parsed.protocol === "http:" || parsed.protocol === "https:") && parsed.host === currentHost) {
      return {
        href: `${parsed.pathname}${parsed.search}${parsed.hash}`,
        isExternal: false,
      };
    }

    return {
      href: trimmedUrl,
      isExternal: true,
    };
  } catch {
    if (/^[a-zA-Z][a-zA-Z\d+.-]*:/.test(trimmedUrl) || trimmedUrl.startsWith("//")) {
      return {
        href: trimmedUrl,
        isExternal: true,
      };
    }

    return {
      href: `https://${trimmedUrl}`,
      isExternal: true,
    };
  }
};

export const getAnchorProps = (url, currentHost) => {
  const { href, isExternal } = classifyLink(url, currentHost);

  return isExternal
    ? {
        href,
        target: "_blank",
        rel: "noopener noreferrer",
      }
    : {
        href,
      };
};
